import React from 'react';
import PropTypes from 'prop-types';
import * as Style from './style';

const SectionTitle = ({
	title,
	subtitle,
	titleSize,
	titleHeight,
	subtitleSize,
	subtitleHeight,
	subtitleMarginBottom,
	titleMarginTop,
	titleMarginBottom,
	marginBottom,
	subtitleColor,
}) => (
	<hgroup style={{ marginBottom }}>
		<div className="row" style={{ width: '100%' }}>
			<div className="col-12">
				<Style.Title
					titleSize={titleSize}
					titleHeight={titleHeight}
					titleMarginTop={titleMarginTop}
					titleMarginBottom={titleMarginBottom}
				>
					{title}
				</Style.Title>
			</div>
			{subtitle && (
			<div className="col-12" data-test="subtitle">
				<Style.Subtitle
					fontSize={subtitleSize}
					lineheight={subtitleHeight}
					subtitleMarginBottom={subtitleMarginBottom}
					subtitleColor={subtitleColor}
				>
					{subtitle}
				</Style.Subtitle>
			</div>
			)}
		</div>
	</hgroup>
);

SectionTitle.defaultProps = {
	titleSize: '18px',
	titleHeight: '35px',
	titleMarginTop: '0',
	titleMarginBottom: '0',
	subtitleSize: '',
	subtitleHeight: '',
	marginBottom: '',
	subtitle: '',
	subtitleMarginBottom: '',
	subtitleColor: '',
};

PropTypes.SectionTitle = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	titleSize: PropTypes.string,
	titleHeight: PropTypes.string,
	titleMarginTop: PropTypes.string,
	titleMarginBottom: PropTypes.string,
	subtitleSize: PropTypes.string,
	subtitleHeight: PropTypes.string,
	marginBottom: PropTypes.string,
	subtitleMarginBottom: PropTypes.string,
	subtitleColor: PropTypes.string,
};

export default SectionTitle;
